import { render, staticRenderFns } from "./AllAgencies.vue?vue&type=template&id=61bc46e3"
import script from "./AllAgencies.vue?vue&type=script&lang=js"
export * from "./AllAgencies.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports